module.exports = __webpack_public_path__ + "img/cta-business-clarity.ef5347a7.webp";